/**
 * Controller: ReportsRemoveModal
 */
angular.module('acme.view.application.reports.removeModal.controllers', [])
.controller('ReportsRemoveModalController', [ '$scope', '$uibModalInstance', 'currentReport', function ($scope, $uibModalInstance, currentReport) {

    $scope.errors = [];

    $scope.model = {
      name: currentReport.name
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);